(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["basz-home-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('basz-home-carousel')) {
    customElements.define('basz-home-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.track = this.querySelector('.basz-home-carousel__track');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-go-to]'));
        this.status = this.querySelector('[data-status]');
        this.rotationButton = this.querySelector('[data-rotation-toggle]');
        this.index = 0;
        if (!this.track || !this.slides.length) return;
        this.isRtl = getComputedStyle(this.track).direction === 'rtl';
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.reducedMotion.matches;
        this.isHovered = this.matches(':hover') && window.matchMedia('(hover: hover)').matches;
        this.hasFocus = this.contains(document.activeElement);
        this.pointerDown = false;
        this.editorSelected = false;
        this.inViewport = !('IntersectionObserver' in window);
        this.isAutoTransition = false;
        this.querySelector('[data-previous]')?.addEventListener('click', () => this.goTo(this.index - 1), options);
        this.querySelector('[data-next]')?.addEventListener('click', () => this.goTo(this.index + 1), options);
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.goTo)), options));
        this.rotationButton?.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.syncAutoplay();
        }, options);
        this.addEventListener('mouseenter', () => {
          this.isHovered = true;
          this.syncAutoplay();
        }, options);
        this.addEventListener('mouseleave', () => {
          this.isHovered = false;
          this.syncAutoplay();
        }, options);
        this.addEventListener('focusin', () => {
          this.hasFocus = true;
          this.syncAutoplay();
        }, options);
        this.addEventListener('focusout', (event) => {
          this.hasFocus = this.contains(event.relatedTarget);
          this.syncAutoplay();
        }, options);
        this.track.addEventListener('pointerdown', () => {
          this.pointerDown = true;
          this.syncAutoplay();
        }, options);
        const releasePointer = () => {
          if (!this.pointerDown) return;
          this.pointerDown = false;
          this.syncAutoplay();
        };
        document.addEventListener('pointerup', releasePointer, options);
        document.addEventListener('pointercancel', releasePointer, options);
        document.addEventListener('visibilitychange', () => this.syncAutoplay(), options);
        this.reducedMotion.addEventListener('change', (event) => {
          if (event.matches) this.userPaused = true;
          this.syncAutoplay();
        }, options);
        this.track.addEventListener('scroll', () => {
          this.clearAutoplay();
          cancelAnimationFrame(this.scrollFrame);
          clearTimeout(this.settleTimer);
          this.scrollFrame = requestAnimationFrame(() => {
            const width = this.track.clientWidth;
            if (!width) return;
            const index = Math.round(Math.abs(this.track.scrollLeft) / width);
            this.activate(Math.max(0, Math.min(this.slides.length - 1, index)), !this.isAutoTransition);
          });
          this.settleTimer = setTimeout(() => {
            this.isAutoTransition = false;
            this.syncAutoplay();
          }, 150);
        }, { ...options, passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track) return;
          let next;
          if (event.key === 'ArrowRight') next = this.index + (this.isRtl ? -1 : 1);
          if (event.key === 'ArrowLeft') next = this.index + (this.isRtl ? 1 : -1);
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.slides.length - 1;
          if (next !== undefined) {
            event.preventDefault();
            this.goTo(next);
          }
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex((slide) => slide === event.target || slide.contains(event.target));
          if (index >= 0) {
            this.editorSelected = true;
            this.syncAutoplay();
            this.goTo(index, false);
          }
        }, options);
        this.addEventListener('shopify:block:deselect', () => {
          this.editorSelected = false;
          this.syncAutoplay();
        }, options);
        this.resizeObserver = new ResizeObserver(() => {
          this.track.scrollTo({ left: (this.isRtl ? -1 : 1) * this.index * this.track.clientWidth, behavior: 'instant' });
        });
        this.resizeObserver.observe(this.track);
        if ('IntersectionObserver' in window) {
          this.visibilityObserver = new IntersectionObserver((entries) => {
            this.inViewport = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.25;
            this.syncAutoplay();
          }, { threshold: [0, 0.25] });
          this.visibilityObserver.observe(this);
        }
        this.activate(0, false);
        this.querySelector('.basz-home-carousel__controls')?.removeAttribute('hidden');
        this.classList.add('is-enhanced');
        this.syncAutoplay();
      }
      canRotate() {
        return this.isConnected && this.slides.length > 1 && !this.userPaused && !this.isHovered && !this.hasFocus && !this.pointerDown && !this.editorSelected && !document.hidden && this.inViewport;
      }
      clearAutoplay() {
        clearTimeout(this.rotationTimer);
        this.rotationTimer = null;
      }
      syncAutoplay() {
        this.clearAutoplay();
        const canRotate = this.canRotate();
        if (!canRotate && this.isAutoTransition) {
          this.isAutoTransition = false;
          const focusedIndex = this.slides.findIndex((slide) => slide.contains(document.activeElement));
          const index = focusedIndex >= 0 ? focusedIndex : this.index;
          this.track.scrollTo({ left: (this.isRtl ? -1 : 1) * index * this.track.clientWidth, behavior: 'instant' });
          this.activate(index, false);
        }
        if (this.rotationButton) {
          this.rotationButton.setAttribute('aria-label', this.userPaused ? this.rotationButton.dataset.playLabel : this.rotationButton.dataset.pauseLabel);
          this.rotationButton.querySelector('[data-pause-icon]').hidden = this.userPaused;
          this.rotationButton.querySelector('[data-play-icon]').hidden = !this.userPaused;
        }
        this.status?.setAttribute('aria-live', canRotate ? 'off' : 'polite');
        if (canRotate) {
          this.rotationTimer = setTimeout(() => {
            this.rotationTimer = null;
            if (this.canRotate()) this.goTo(this.index + 1, true, true);
          }, 6000);
        }
      }
      goTo(index, animate = true, automatic = false) {
        this.clearAutoplay();
        clearTimeout(this.settleTimer);
        this.isAutoTransition = automatic;
        if (this.status) this.status.setAttribute('aria-live', automatic ? 'off' : 'polite');
        const next = (index + this.slides.length) % this.slides.length;
        this.track.scrollTo({
          left: (this.isRtl ? -1 : 1) * next * this.track.clientWidth,
          behavior: animate && !this.reducedMotion.matches ? 'smooth' : 'instant'
        });
        this.settleTimer = setTimeout(() => {
          this.isAutoTransition = false;
          this.syncAutoplay();
        }, 150);
      }
      activate(index, announce) {
        const changed = this.index !== index;
        this.slides.forEach((slide, position) => {
          const active = position === index;
          if (!active && slide.contains(document.activeElement)) this.track.focus({ preventScroll: true });
          slide.inert = !active;
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.dots.forEach((dot, position) => {
          if (position === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        this.index = index;
        if (announce && changed && this.status) this.status.textContent = this.slides[index].getAttribute('aria-label');
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.clearAutoplay();
        clearTimeout(this.settleTimer);
        cancelAnimationFrame(this.scrollFrame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["basz-ingredient-guide"]) return;
  try {
    
  function initializeBaszIngredients(root) {
    root.querySelectorAll('[data-ingredient-guide]').forEach((guide) => {
      if (guide.dataset.initialized) return;
      guide.dataset.initialized = 'true';
      const gallery = guide.querySelector('[data-ingredient-gallery]');
      const cards = Array.from(gallery.children);
      const previous = guide.querySelector('[data-ingredient-previous]');
      const next = guide.querySelector('[data-ingredient-next]');
      const position = guide.querySelector('[data-ingredient-gallery-position]');
      const mobileGallery = window.matchMedia('(max-width: 749px)');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let currentCard = 0;
      let scrollFrame;
      function updateGallery() {
        const galleryBounds = gallery.getBoundingClientRect();
        let closestDistance = Infinity;
        cards.forEach((card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - galleryBounds.left);
          if (distance < closestDistance) {
            closestDistance = distance;
            currentCard = index;
          }
        });
        const atEnd = Math.abs(gallery.scrollLeft) + gallery.clientWidth >= gallery.scrollWidth - 2;
        if (atEnd && mobileGallery.matches) currentCard = cards.length - 1;
        previous.disabled = currentCard === 0;
        next.disabled = currentCard === cards.length - 1;
        position.textContent = position.dataset.positionLabel.replace('__CURRENT__', String(currentCard + 1));
      }
      function moveGallery(direction) {
        if (!mobileGallery.matches) return;
        const targetIndex = Math.max(0, Math.min(cards.length - 1, currentCard + direction));
        const distance = cards[targetIndex].getBoundingClientRect().left - gallery.getBoundingClientRect().left;
        gallery.scrollBy({ left: distance, behavior: reduceMotion.matches ? 'instant' : 'smooth' });
      }
      previous.addEventListener('click', () => moveGallery(-1));
      next.addEventListener('click', () => moveGallery(1));
      gallery.addEventListener('scroll', () => {
        cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(updateGallery);
      }, { passive: true });
      gallery.addEventListener('keydown', (event) => {
        if (!mobileGallery.matches || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        moveGallery(event.key === 'ArrowRight' ? 1 : -1);
      });
      function refreshGallery() {
        if (mobileGallery.matches) gallery.setAttribute('tabindex', '0');
        else gallery.removeAttribute('tabindex');
        updateGallery();
      }
      guide.dataset.galleryEnhanced = 'true';
      guide.querySelector('[data-ingredient-gallery-controls]').hidden = false;
      mobileGallery.addEventListener('change', refreshGallery);
      refreshGallery();
      const input = guide.querySelector('[data-ingredient-search]');
      const category = guide.querySelector('[data-ingredient-category]');
      const entries = Array.from(guide.querySelectorAll('[data-ingredient]'));
      const count = guide.querySelector('[data-ingredient-count]');
      const empty = guide.querySelector('[data-ingredient-empty]');
      const normalize = (value) => value.toLocaleLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
      const searchable = entries.map((entry) => normalize(entry.textContent));
      function filterIngredients() {
        const words = normalize(input.value).trim().split(/\s+/).filter(Boolean);
        let shown = 0;
        entries.forEach((entry, index) => {
          const match = (!category.value || entry.dataset.category === category.value) && words.every((word) => searchable[index].includes(word));
          entry.hidden = !match;
          if (match) shown += 1;
        });
        count.textContent = guide.dataset.countLabel.replace('__COUNT__', String(shown));
        empty.hidden = shown !== 0;
      }
      input.addEventListener('input', filterIngredients);
      category.addEventListener('change', filterIngredients);
      guide.querySelector('[data-ingredient-clear]').addEventListener('click', () => {
        input.value = '';
        category.value = '';
        filterIngredients();
        input.focus();
      });
      guide.querySelector('[data-ingredient-controls]').hidden = false;
      filterIngredients();
    });
  }
  initializeBaszIngredients(document);
  document.addEventListener('shopify:section:load', (event) => initializeBaszIngredients(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
